import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
        <p style={{ textAlign: "justify" }}>
        Hi Everyone, I am <span className="purple">Muhammet Fatih Özata </span>
        from <span className="purple"> Antalya, Turkey.</span>
        <br /> I recently graduated from Antalya Bilim University with a degree in Computer Engineering.
        I am a Jr .NET developer who is eager to find a job and has goals for self-improvement.
        I have wonderful dreams, and I live my life to turn these dreams into goals and then into reality.
        <br />
        Additionally, I am excited to start my journey in the world of software development.
        <br />
        <br />
        Apart from coding, some other activities that I love to do!
        </p>
          <ul>
            <li className="about-activity">
              <ImPointRight /> Watching Movies
            </li>
            <li className="about-activity">
              <ImPointRight /> Camping
            </li>
            <li className="about-activity">
              <ImPointRight /> Travelling
            </li>
          </ul>

          <p style={{ color: "rgb(155 126 172)" }}>
            Computer Engineering (Full Scholarship),
            Antalya Bilim University, GPA 2.89
          </p>
          <footer className="blockquote-footer">Antalya/Türkiye</footer>
        </blockquote>
      </Card.Body>

      <Card.Body className="cv-experience">
        <h2>Experience</h2>
        <div className="experience">
          <h4>Ledbim Bilişim Danışmanlık ve Ticaret Anonim Şirketi</h4>
          <p className="experience-details">
            <em>Intern</em> | Jan 2022 – Aug 2022 | Antalya, Turkey
          </p>
          <ul className="experience-description">
            <li>Learned the fundamentals of the C# language.</li>
            <li>Learned database usage in detail like relational tables, keys, etc.</li>
            <li>Learned the DB first approach using Dapper, designed and coded project "CdCenter" with my mentor.</li>
            <li>Learned the purpose and usage of Layered Architecture on .Net and coded a small project "FAQ.API".</li>
            <li>Learned the purpose, usage, and technologies used in .NET technology such as Swagger, Redis, MediatR, Aggregator, Microservice.</li>
          </ul>
        </div>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;